export default "__VITE_ASSET__miEH3fbc__"